import {Component, ChangeDetectionStrategy} from "@angular/core";

@Component({
    selector: 'knust-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    // Nicht OnPush: Darunter liegen Eager-Komponenten, die Werte in subscribe() setzen. Unter einer OnPush-Wurzel
    // würden sie nur noch nach Events aktualisiert (z. B. Warenkorb-Anzahl erst beim nächsten Klick).
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- siehe oben
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {}
